import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Column } from '@narvar/nth-grid';

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  margin: 1rem;
`;

const ModalSectionHeader = styled.h3`
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
`;

const ModalSectionDetails = styled.p`
  font-size: 0.9rem;
`;

const ModalSection = ({ icon, title, description, colWidth }) => (
  <Column md-columns={colWidth}>
    {icon && <IconContainer>{icon}</IconContainer>}
    {title && <ModalSectionHeader>{title}</ModalSectionHeader>}
    {description && <ModalSectionDetails>{description}</ModalSectionDetails>}
  </Column>
);

ModalSection.defaultProps = {
  icon: null,
  title: '',
  description: '',
};

ModalSection.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  colWidth: PropTypes.number.isRequired,
};

export default ModalSection;
